import React from "react";
import _ from "lodash";
import { ContainerItem } from "containers/Task/detail/detail.styled";
import { applyTextType } from "utils";
import { DividerH } from "../styled";
import { useTranslation } from "react-i18next";

const ContainerItemPerson = ({ keyText, itemText }) => {
  const { t } = useTranslation();

  if (
    !itemText.value &&
    ![0, 1].includes(itemText.value) &&
    (itemText?.format !== "boolean" || typeof itemText.value === "undefined")
  ) {
    return (
      <ContainerItem
        key={keyText}
        marginTop={[0, 1].includes(keyText) ? "0px" : "16px"}
      >
        <div>
          <strong>{itemText?.label}: </strong>
          {_.upperFirst(t("no_information"))}
        </div>
      </ContainerItem>
    );
  }
  if (itemText?.format === "percentage") {
    let percentage = parseFloat(itemText?.value);
    if (percentage <= 1) {
      percentage = (percentage * 100).toFixed(itemText?.formatString);
    } else {
      percentage = percentage.toFixed(itemText?.formatString);
    }
    return (
      <ContainerItem
        key={keyText}
        marginTop={[0, 1].includes(keyText) ? "0px" : "16px"}
      >
        <strong>{itemText.label}</strong>
        <div className="item-description">
          {applyTextType(
            percentage,
            itemText?.format,
            itemText?.extension,
            itemText?.formatString,
            _.upperFirst(t("no_information"))
          )}
        </div>
      </ContainerItem>
    );
  }
  return (
    <ContainerItem
      key={keyText}
      marginTop={[0, 1].includes(keyText) ? "0px" : "16px"}
    >
      <strong>{itemText.label}</strong>
      {itemText.format !== "array" && (
        <div className="item-description">
          {applyTextType(
            itemText.value,
            itemText.format,
            itemText.extension,
            itemText.format_string
          )}
        </div>
      )}
      {itemText.format === "array" && (
        <div className="item-description">
          {itemText.value &&
            itemText.value.map((itemArray, keyArray) => {
              return (
                <div key={`key-value-${keyArray}`}>
                  <div
                    className="d-flex justify-content-between"
                    style={{
                      flexWrap: "wrap",
                    }}
                  >
                    {itemText.items.map((item, key) => {
                      return (
                        <div
                          key={`item-${keyArray}-${key}`}
                          className="flex-basis-50"
                          style={{ flexBasis: "50%" }}
                        >
                          <ContainerItem>
                            <strong>{item.label}</strong>
                            <div className="item-description">
                              {applyTextType(
                                itemArray[item.key_value] ?? "",
                                item.format,
                                item.extension,
                                item.format_string
                              )}
                            </div>
                          </ContainerItem>
                        </div>
                      );
                    })}
                  </div>
                  <DividerH
                    style={{
                      marginTop: "16px",
                      marginBottom: "16px",
                    }}
                  />
                </div>
              );
            })}
        </div>
      )}
    </ContainerItem>
  );
};
export default ContainerItemPerson;
